export default function register() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      const version = Number(__SW_VERSION__)
      const swUrl = `/service-worker.js?v=${version}`
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          registration.onupdatefound = () => {
            const installingWorker = registration.installing
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('有新版本，请刷新页面')
                } else {
                  console.log('Content is cached for offline use.')
                }
              }
            }
          }
        })
        .catch((error) => {
          console.error('Error during service worker registration:', error)
        })
    })
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister()
    })
  }
}
